/* ==========================================================================
   Rook UI Core — Progress Controller
   Web Component: <rk-progress-element>
   ========================================================================== */

if (!customElements.get('rk-progress-element')) {
    class RkProgressElement extends HTMLElement {
        constructor() {
            super();
            this.indicator = null;
        }

        connectedCallback() {
            this.indicator = this.querySelector('.rk-progress__indicator');
            if (!this.indicator) return;

            // Initialize position
            this._updateIndicator();

            // Observe data attribute changes for reactive updates
            this.observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.type === 'attributes' &&
                        (mutation.attributeName === 'data-value' || mutation.attributeName === 'data-max')) {
                        this._updateIndicator();
                    }
                });
            });

            this.observer.observe(this, { attributes: true });
        }

        disconnectedCallback() {
            if (this.observer) {
                this.observer.disconnect();
            }
        }

        /* ------------------------------------------------------------------ */
        /*  Public API                                                        */
        /* ------------------------------------------------------------------ */

        get value() {
            const val = parseFloat(this.getAttribute('data-value'));
            return isNaN(val) ? 0 : val;
        }

        set value(val) {
            this.setAttribute('data-value', val);
        }

        get max() {
            const m = parseFloat(this.getAttribute('data-max'));
            return (isNaN(m) || m <= 0) ? 100 : m;
        }

        set max(m) {
            this.setAttribute('data-max', m);
        }

        _updateIndicator() {
            let percentage = (this.value / this.max) * 100;

            // Clamp between 0 and 100
            percentage = Math.max(0, Math.min(100, percentage));

            // Update ARIA 
            const progressBar = this.querySelector('[role="progressbar"]');
            if (progressBar) {
                progressBar.setAttribute('aria-valuenow', this.value);
                progressBar.setAttribute('aria-valuemax', this.max);
            }

            // Animate using transform (hardware accelerated)
            // By default, it's translated to -100%. We calculate how much to translate back towards 0%.
            this.indicator.style.transform = `translateX(-${100 - percentage}%)`;
        }
    }

    customElements.define('rk-progress-element', RkProgressElement);
}
